import emptyState from './state'

export function rootReducer(state = emptyState, action) {
    if (typeof(action.reduce) == 'function') {
        return action.reduce(state)
    }
    return state
}
